module.exports = __webpack_public_path__ + "product-management-hero-a3bcc196b60efc8e5ee36bea05ae380b.webp";